<div class="cancel-page">
  <div class="cancel-card">
    <div class="cancel-icon">
      <i class="pi pi-times-circle"></i>
    </div>
    <h2 class="cancel-title">Compra não concluída</h2>
    <p class="cancel-desc">
      Você cancelou o processo de pagamento. Nenhum token foi cobrado.
    </p>
    <p-button
      label="Voltar"
      icon="pi pi-home"
      class="p-button-cancel"
      (onClick)="goToDashboard()" />
  </div>
</div>
